import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import { camelCase } from 'lodash'
import RainPanelUI from '@/components/top/panels/RainPanel/RainPanelUI.vue'
import { DefinitionInfoSummaryItemCommon } from '@/models/initData/DefinitionInfo'
import { usePresentStore } from '@/stores/presentStore'
import { useInitDataStore } from '@/stores/initDataStore'

type Element = {
  id: string
  type: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoSummaryItemCommon>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const FIELD_NAME_SHOTEN_DICT = {
  '10分移動積算雨量': '10分雨量',
  '1時間移動積算': '時間雨量',
}

const presentStore = usePresentStore()
const initDataStore = useInitDataStore()
const router = useRouter()

const getStationName = (stationId: string) => {
  const station = initDataStore.initData.stations.findById(stationId)

  return station?.name || ''
}

const cell = computed(() => props.cell)

const renderValue = (value?: number, decimal?: number) => {
  if (value === undefined || value === null) {
    return '-'
  }

  return value.toFixed(decimal)
}

const elementToRow = (element: Element, stationId: string) => {
  const { id } = element
  const valueRaw = presentStore.getValue(stationId, id) as number
  const decimal = initDataStore.getDecimal(element.id) as number
  const value = renderValue(valueRaw, decimal)
  const unit = initDataStore.getUnit(id)
  let fieldName = initDataStore.fieldListItem(camelCase(element.id))?.name

  fieldName = FIELD_NAME_SHOTEN_DICT[fieldName as keyof typeof FIELD_NAME_SHOTEN_DICT] || fieldName

  return {
    type: id,
    value,
    unit,
    fieldName,
  }
}

const cellToParams = (cell: DefinitionInfoSummaryItemCommon) => {
  const { no, stationId } = cell.args
  const stationName = getStationName(stationId)
  const updatedAt = presentStore.getTime(cell.args.stationId, 'HH:mm')
  const rows = cell.args.element.map(element => elementToRow(element, stationId))

  return {
    no,
    stationName,
    updatedAt,
    rows,
  }
}

const params = computed(() => cellToParams(cell.value))

const onClick = () => {
  const path = `/rain_detail/${cell.value.args.stationId}`

  router.push(path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RainPanelUI, _mergeProps({ onClick: onClick }, _unref(params)), null, 16))
}
}

})